import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

const ResetStyle = createGlobalStyle`
	${normalize}
`;

export default ResetStyle;
